import { render, staticRenderFns } from "./videoupload-add-or-update.vue?vue&type=template&id=51e313bb&scoped=true&"
import script from "./videoupload-add-or-update.vue?vue&type=script&lang=js&"
export * from "./videoupload-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./videoupload-add-or-update.vue?vue&type=style&index=0&id=51e313bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e313bb",
  null
  
)

export default component.exports